import ZonePool from "@gik/ads/ZonePool";
import { useEnvStore } from "@gik/core/store/EnvStore";

type AdGlareZonesType = {
	[_: string]: string;
};

let AdGlareZones: AdGlareZonesType;

try {
	AdGlareZones = useEnvStore.getState().ADGLARE_ZONES
		? JSON.parse(useEnvStore.getState().ADGLARE_ZONES)
		: {};
} catch (e) {
	AdGlareZones = {};
}

const getAdZone = (zoneName: string): string => {
	try {
		return AdGlareZones[zoneName] || "";
	} catch (e) {
		return "";
	}
};

const getAdPoolZone = (zoneName: string): string[] => {
	try {
		return getAdZone(zoneName).split(",");
	} catch (e) {
		return [];
	}
};

export default abstract class ZonesMap {
	public static readonly BlogZones = {
		Top: getAdZone("BLOG_TOP"),
		TopMobile: getAdZone("TOP_MOBILE"),
		Middle: getAdZone("BLOG_MIDDLE"),
		MiddleMobile: getAdZone("BLOG_MIDDLE_MOBILE"),
		Bottom: getAdZone("BLOG_BOTTOM"),
		BottomMobile: getAdZone("BLOG_BOTTOM_MOBILE"),
	};

	public static readonly ArticleZones = {
		Right: getAdZone("ARTICLE_RIGHT"),
		Bottom: getAdZone("ARTICLE_BOTTOM"),
		BottomMobile: getAdZone("ARTICLE_BOTTOM_MOBILE"),
		// LinkCard is the situation articles page, it loads ads dynamically and since adglare doesnt allow repeated zones on the same page I needed to come up with this dynamic allocation "ZonePool"
		LinkCard: new ZonePool(getAdPoolZone("ARTICLE_LINK_CARD_POOL")),
		LinkCardMobile: new ZonePool(
			getAdPoolZone("ARTICLE_LINK_CARD_POOL_MOBILE"),
		),
	};
}
